import { render } from "./ourClientsSection.vue?vue&type=template&id=676457a6"
import script from "./ourClientsSection.vue?vue&type=script&lang=js"
export * from "./ourClientsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__